<template>
  <span
    class="copy"
    v-clipboard:copy="text"
    v-clipboard:success="copyNumber">
    <inline-svg
      class="table-column-status__icon"
      :src="require(`@/assets/svg/copy.svg`)"/>
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    textMessage: {
      type: String,
      required: true
    }
  },
  methods: {
    copyNumber() {
      this.$toasted.global.all_ok(this.textMessage);
    }
  }
}
</script>

<style lang="scss" scoped>
.copy {
  cursor: pointer;
}
</style>